<template>
  <div align="center" class="col s4" @click="detalhes()" style="height: 140px;" :id="'gid'+grupo.grupo.id">
    <img v-if="grupo.grupo.grupo_imagem" :src="grupo.grupo.grupo_imagem" :alt="grupo.grupo.nome"
         class="circle responsive-img destaque" :style="'border-color: '+this.$store.state.empresa.cor_primaria"/>
    <img v-else src="../../../assets/no-image-1.jpg" :alt="grupo.grupo.nome" class="circle responsive-img destaque"
         :style="'border-color: '+this.$store.state.empresa.cor_primaria"/>
    <div align="center">
      <strong class="textline" style="font-size: x-small;font-weight: bold">{{ grupo.grupo.nome }}</strong>
    </div>
  </div>
</template>

<script>
import SecureLS from "secure-ls";

export default {
  name: "Destaques",
  props: ["grupo"],
  methods: {
    detalhes() {
      var ls = new SecureLS();
      ls.set('grupo', this.grupo);
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/grupo/' + this.grupo.grupo.nome + '/secao/' + 0 + '?grupo=' + this.grupo.grupo.id)
    }
  }
}
</script>

<style scoped>
.destaque {
  object-fit: cover;
  min-height: 80px;
  height: 80px;
  min-width: 80px;
  width: 80px;
  border-style: solid
}

.textline {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/Grupos/Destaques.vue